// client/src/coms/components/TrustDialog.js
// Shown before installing or importing content made by someone else (sticker packs, sound collections).
import React, { useState } from 'react';

export const IMPORT_WARNING =
  'Only install shared content from sources you trust. Files shared by other users, including friends, may contain harmful or inappropriate content. Voxemera checks supported files, but no automated check can guarantee safety.';

export function formatBytes(n) {
  const v = Number(n) || 0;
  if (v < 1024) return `${v} B`;
  if (v < 1024 * 1024) return `${(v / 1024).toFixed(1)} KB`;
  return `${(v / 1024 / 1024).toFixed(1)} MB`;
}

// info: { name, creator, count, bytes, types, permissions? }
export default function TrustDialog({ title = 'Install shared content?', info, onCancel, onConfirm, busy, confirmLabel = 'Install' }) {
  const [ok, setOk] = useState(false);
  return (
    <div role="dialog" aria-modal="true" aria-label={title} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16 }}>
      <div style={{ width: 'min(460px, 100%)', background: 'var(--vxs-3, #1b1c1f)', border: '1px solid rgba(var(--vx-fg-rgb, 255,255,255), calc(0.12 * var(--vx-ov, 1)))', borderRadius: 14, padding: 18, color: 'var(--vx-text, #fff)' }}>
        <div style={{ fontSize: 17, fontWeight: 900 }}>{title}</div>
        <div style={{ marginTop: 10, padding: 10, borderRadius: 10, background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.4)', fontSize: 13, lineHeight: 1.45 }}>{IMPORT_WARNING}</div>
        <table style={{ marginTop: 12, fontSize: 13, borderSpacing: '8px 4px' }}>
          <tbody>
            <tr><td style={{ opacity: 0.7 }}>Name</td><td>{info.name}</td></tr>
            <tr><td style={{ opacity: 0.7 }}>Creator</td><td>{info.creator || 'Unknown'}</td></tr>
            <tr><td style={{ opacity: 0.7 }}>Files</td><td>{info.count}</td></tr>
            <tr><td style={{ opacity: 0.7 }}>Size</td><td>{formatBytes(info.bytes)}</td></tr>
            <tr><td style={{ opacity: 0.7 }}>File types</td><td>{(info.types || []).join(', ') || 'unknown'}</td></tr>
            <tr><td style={{ opacity: 0.7 }}>Permissions</td><td>{info.permissions || 'None'}</td></tr>
          </tbody>
        </table>
        <label style={{ display: 'flex', gap: 8, marginTop: 12, fontSize: 13 }}>
          <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} />I trust this source
        </label>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
          <button type="button" className="coms-mini-btn" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="coms-mini-btn primary" onClick={onConfirm} disabled={!ok || busy}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
